import { create } from 'zustand';

interface CurrencyState {
  currencyCode: string;
  isFetching: boolean;
  fetchCurrency: () => Promise<void>;
}

const getCrmBackendUrl = () => {
  const isLocalHost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (isLocalHost) {
    return `http://${window.location.hostname}:8000`;
  }

  const hostname = window.location.hostname;
  if (hostname.includes('dealbox-hr')) {
    return `https://${hostname.replace('dealbox-hr', 'dealbox-crm')}`;
  }
  if (hostname.includes('hr')) {
    return `https://${hostname.replace('hr', 'crm')}`;
  }
  return `https://${hostname}`;
};

export const useCurrencyStore = create<CurrencyState>()((set) => ({
  currencyCode: 'USD',
  isFetching: false,

  fetchCurrency: async () => {
    set({ isFetching: true });
    try {
      const tenantId = localStorage.getItem('tenant_id') || localStorage.getItem('selected_tenant_id');
      const headers: any = { 'Content-Type': 'application/json' };
      if (tenantId) headers['X-Tenant-ID'] = tenantId;

      const url = `${getCrmBackendUrl()}/api/settings/currency`;
      const response = await fetch(url, { credentials: 'include', headers });
      
      if (response.ok) {
        const data = await response.json();
        if (data && data.currency) {
          set({ currencyCode: data.currency });
        }
      }
    } catch (error) {
      console.error('Failed to fetch global currency:', error);
    } finally {
      set({ isFetching: false });
    }
  },
}));
